import state from "./state";
import ApiService from "@/core/services/api.service";

export default {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  fetchTeacherGroupMemberInList(context, payload) {
    ApiService.setHeader();
    return ApiService.query("school/group/employees", {
      params: {
        "page[size]": 30,
        "page[number]": state.pagination.current_page ?? 1,
        "filter[first_name]": state.filters.name,
        id: payload.id,
        employee_type: 1,
      },
    }).then((res) => {
      context.commit("setTeacherGroupMemberInList", res.data.data);
      context.commit(
        "setTeacherGroupMemberInListPagination",
        res.data.meta.pagination
      );
      return res;
    });
  },

  /**
   *
   * @param context
   * @param payload
   */
  changeTeacherGroupMemberInListNameFilters(context, payload) {
    console.log("Name", payload.name);

    let curFilters = state.filters;
    curFilters.name = payload.name;

    context.commit("setTeacherGroupMemberInListFilters", curFilters);
  },

  /**
   *
   * @param context
   * @param payload
   */
  selectTeacherGroupMemberDeleteModification(context, payload) {
    console.log("Info : ", context, payload);

    context.commit("switchTeacherGroupMemberSelectionDelete", payload.id);
  },
};
